"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IRREGULAR = exports.ANNUALLY = exports.QUARTERLY = exports.MONTHLY = exports.TWICE_MONTHLY = exports.BI_WEEKLY = exports.WEEKLY = void 0;
var WEEKLY = 'weekly';
exports.WEEKLY = WEEKLY;
var BI_WEEKLY = 'biWeekly';
exports.BI_WEEKLY = BI_WEEKLY;
var TWICE_MONTHLY = 'twiceMonthly';
exports.TWICE_MONTHLY = TWICE_MONTHLY;
var MONTHLY = 'monthly';
exports.MONTHLY = MONTHLY;
var QUARTERLY = 'quarterly';
exports.QUARTERLY = QUARTERLY;
var ANNUALLY = 'annually';
exports.ANNUALLY = ANNUALLY;
var IRREGULAR = 'irregular';
exports.IRREGULAR = IRREGULAR;